import { Component, OnInit,Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { MenuItem } from 'primeng/api';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-create',
  templateUrl: './create.page.html',
  styleUrls: ['./create.page.scss'],
})
export class CreatePage implements OnInit {
  @Input() company;
  @Input() edit_mode = false;
  items: MenuItem[];
  activeIndex = 0;
  @Input() group = {
    guid: '',
    title: '',
    description: '',
    colour: '',
    clients: []
  }


  constructor(private modalController: ModalController, private apiService: ApiService,public globalService: GlobalService) { }

  ngOnInit() {
    //Create a copy of the company
    this.company = JSON.parse(JSON.stringify(this.company));
    this.items = [
      { label: 'Basic Information' },
      { label: 'Add Contacts' },
      { label: 'Review' }
    ];
    if(this.edit_mode) this.RemoveDuplicateClients();
  }

  async RemoveDuplicateClients() {
    this.group.clients.forEach(cli => {
      this.company.clients.splice(this.company.clients.findIndex(item => item.guid === cli.guid), 1);
    });
  }

  async RemoveClient(client) {
    this.group.clients.splice(this.group.clients.findIndex(item => item.guid === client.guid), 1);
  }

  async GoToStep(step) {
    this.activeIndex = step;
  }
  async Close() {
    this.modalController.dismiss(null);
  }

  async Create() {
    let data: any = await this.apiService.post(`companies/groups/clients/${this.company.guid}`,this.group);
    this.globalService.presentToastMessage(data.message,data.success);
    if(data.success) this.modalController.dismiss(this.group);
  }

  async Update() {
    let data: any = await this.apiService.put(`companies/groups/clients/${this.company.guid}`,this.group);
    this.globalService.presentToastMessage(data.message,data.success);
    if(data.success) this.modalController.dismiss(this.group);
  }

}
